module.exports = __webpack_public_path__ + "img/category-3.ecfc3365.svg";